import React, { Component } from 'react';
import { get, post } from '../utils/request';
import { regExpression, isWeChat, deleteUrlKey } from '../utils/util';

class LoginDom extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasLogin: true, // 为避免请求登录信息未完成的情况下闪一下登录模块 设置为true
      canSendSms: true,
      canSendVoice: true,
      smsSec: 60,
      voiceSec: 60,
      phoneErrTxt: '手机号格式不正确'
    }
    this.loginInfo = { ...props };
    this.loginInfo.userLoginInfo = {}; // 初始化
  }
  componentDidMount () {
    const urlValues = this.loginInfo.urlValues;
    // set vendor 
    if (urlValues && urlValues.xfzvendor) { sessionStorage.setItem("UserVendor", urlValues.xfzvendor) }
    // 获取用户是否已经登录的信息
    const getUserInfo = () => {
      get('/api/website/user/info/')
      .then(res => {
        if (res.code === 200) {
          this.loginInfo.userLoginInfo = res.data;
        }
        // 已经绑定手机号( code:200 代表登录，但是否有手机号未知)
        if (res.data.phone) {
          this.state.hasLogin = true;
          this.loginInfo.userLoginInfo.phone = res.data.phone;
        } else {
          // 没有手机号（未登录code403或登录没有手机号code200phone为空）
          if (isWeChat() && !!!urlValues.code) {
            return window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${window.formGlobalData.appId}&redirect_uri=` + encodeURIComponent(window.location.href) + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
          }
          // 微信授权登录后检测该微信号是否已经绑定手机号
          if (isWeChat() && urlValues.code) {
            return wechatCheck();
          }
          // pc 浏览器
          else {
            this.state.hasLogin = false;
          }
        }
        this.returnLoginData(this.loginInfo); // 返回数据
      })
    }
    
    // check 微信号和手机号是否绑定
    const wechatCheck = () => {
      get('/api/website/weixin/service/check/', {
        params: {
          code: urlValues.code
        }
      }).then(res => {
        // 已经绑定手机号
        if (res.code === 200 && res.data.is_bind) {
          this.state.hasLogin = true; 
          this.loginInfo.userLoginInfo = res.data;
          if (res.data.phone) {
            this.loginInfo.userLoginInfo.phone = res.data.phone
          }
          if (res.data.member_id) {
            this.loginInfo.userLoginInfo.uid = res.data.member_id
          }
        }
        // 如果是code报错或者微信取不到个人信息的情况
        else if (res.code === 501){
          return window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${window.formGlobalData.appId}&redirect_uri=` + encodeURIComponent(deleteUrlKey('code')) + '&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect';
        }
        // 其余未绑定的情况下 需要绑定手机号
        else {
          this.state.hasLogin = false; 
        }
        this.returnLoginData(this.loginInfo); // 已登录且微信已经绑定手机号的情况返回数据
      })
    }
    // 获取用户是否登录的信息
    getUserInfo();
  }
  returnLoginData = (returnData) => {
    this.props.receiveData({
      userLoginInfo: returnData.userLoginInfo,
      hasLogin: this.state.hasLogin
    });
    this.setState({
      hasLogin: this.state.hasLogin
    })
  }
  handelChange = (event) => {
    const key = event.target.name;
    const value = event.target.value;
    this.setState({
      [key]:value
    }, () => {
      if (key === 'phone' && value && value.length === 11) {
        this.validate();
      }
    })
  }
  validate = () => {
    if(regExpression().phoneReg.test(this.state.phone)) {
      this.setState({
        showPhoneErr: false
      })
      return true;
    } else {
      this.setState({
        showPhoneErr: true,
        phoneErrTxt: '手机号格式不正确'
      })
      return false;
    }
  }
  // 默认使用 一，有人攻击则使用方法二
  // 方法一：使用腾讯验证码登陆
  getCaptchaTencent = (event) => {
    const target = event.target;
    const type = target.getAttribute('type');
    const self = this
    // 腾讯验证码
    var tCaptcha = new window.TencentCaptcha('2099851887', function(tencentRes) {
      self.requestSmsCode(type, tencentRes)
    });
    tCaptcha.show(); // 显示验证码
  }
  // 方法二：使用普通 code 登陆
  getCaptcha = (event) => {
    const target = event.target;
    const type = target.getAttribute('type');
    this.requestSmsCode(type, {})
  }
  requestSmsCode = (type, tencentRes) =>{
    const flagKey = type === 'sms' ? 'canSendSms' : 'canSendVoice';
    if (this.validate() && this.state[flagKey]) {
      post('/api/website/sms_captcha/', {
        phone: this.state.phone,
        type: type,
        captcha: '20e40ac7620647099bb2cbae50bd62fc',
        randstr: tencentRes.randstr || '',
        ticket: tencentRes.ticket || '',
      }, {
        headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'}
      }).then(res => {
        if (res.code === 200) {
          // 设置flag
          this.setState({
            [flagKey]: false
          })
          secDao();
        } else if (res.code === 1104) {
          this.setState({
            phoneErrTxt: '操作过于频繁，请1分钟后重试',
            showPhoneErr: true
          })
        } else {
          this.setState({
            phoneErrTxt: res.data.message,
            showPhoneErr: true
          })
        }
      })
    }
    const secDao = () => {
      // 倒计时函数
      const Time = (sec, type) => {
        let timer = setInterval(() => {
          if (sec > 0) {
            sec --;
            this.setState({
              [type]: sec
            });
          } else {
            clearInterval(timer);
            // 恢复可点击
            this.setState({
              [flagKey]: true,
              [type]: 60
            });
          }
        }, 1000);
      }
      // sms验证码
      if (type === 'sms') {
        Time(this.state.smsSec, 'smsSec');
      }
      // 语音验证码
      else {
        Time(this.state.voiceSec, 'voiceSec');
      }
    }
  }

  submitLogin = () => {
    // 校验手机号规则
    if (this.validate()) {
      // 校验验证码是否输入
      if (!this.state.captcha) {
        this.setState({
          showCapErr: true
        })
        return;
      }
      // 登录请求
      if (isWeChat() && this.loginInfo.urlValues.code) {
        // 微信登录
        post('/api/website/weixin/service/bind/', {
          code: this.loginInfo.urlValues.code, 
          phone: this.state.phone, 
          captcha: this.state.captcha
        }, {
          headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'}
        }).then(res => {
          if (res.code === 200) {
            this.loginInfo.userLoginInfo = res.data;
            this.state.hasLogin = true;
            this.returnLoginData(this.loginInfo); // 绑定微信后登录成功返回数据
          } else {
            this.setState({
              showCapErr: true
            })
          }
        })
      } else {
        // 非微信登录
        post('/api/website/user/login/ensure/', {
          phone: this.state.phone, 
          captcha: this.state.captcha
        }, {
          headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'}
        }).then(res => {
          if (res.code === 200) {
            this.loginInfo.userLoginInfo = res.data;
            this.state.hasLogin = true;
            this.returnLoginData(this.loginInfo); // 登录成功后的情况返回数据
          } else {
            this.setState({
              showCapErr: true
            })
          }
        })
      }      
    }
  }
  render() {
    // 如果是已经登录的情况
    if (this.state.hasLogin) {
      return null;
    }
    // 未登录
    let showType = '';
    switch(this.props.type) {
      case "创业课堂":
      case "垂直班":
      case "A轮班":
        showType = '立即报名课堂';break;
      case "主题游学":
      case "定制游学":
        showType = '立即报名游学';break;
      case "沙龙":
        showType = '立即报名沙龙';break;
      case "媒体报道":
        showType = '登记报道信息';break;
      default:
        showType = '立即报名活动';break;
    }
    return (
      <div className="login-wrapper need-clear">
        <div className="login-title">
          {showType}
        </div>
        <div className="login-item">
          <label>手机号:</label><input type="text" maxLength="11" name="phone" className="phone-number" placeholder="仅限大陆手机号" onChange={this.handelChange}></input>{this.state.showPhoneErr && <span className="login-err-tips">{this.state.phoneErrTxt}</span> }
        </div>
        <div className="login-item">
          <label>验证码:</label><input type="number" name="captcha" className="captcha" onChange={this.handelChange}></input>
          <span className={this.state.canSendSms ? "send-text-captcha s-button" : "send-text-captcha s-button disabled"} onClick={this.getCaptcha} type="sms">{ this.state.canSendSms ? '获取验证码' : `${this.state.smsSec}s`}</span>{this.state.showCapErr && <span className="login-err-tips">验证码不正确</span>}
        </div>
        {this.state.canSendVoice ? <p className="p-voice">收不到验证码？<span className="send-voice-captcha" onClick={this.getCaptcha} type="voice">点此接收语音验证码</span></p> : <p className="voice-tips">正在拨打电话，请稍后{this.state.voiceSec}s后可重试</p>}
        <div className="login-submit m-button" onClick={this.submitLogin}>提交</div>
      </div>
    )
  }
}

export default LoginDom;
